export default __webpack_public_path__ + "static/media/cameraDesktop@2x.0dc28393.png";